import {type Expression} from '@packages/systems/wfdl-ast';
import type {QualifiedPluginIcon} from '../Plugins/PluginIconTypes';

// Opaque type removed - see /packages/utilities/type-safety/README.md for more information
export type ValuePresetName = string;

export type ValuePresetCategory = string;

type ValuePresetHelpData = {
  /** Additional information about the preset. */
  description: string;
};

export type ValuePresetIcons = {
  medium: QualifiedPluginIcon;
  small: QualifiedPluginIcon;
};

export type ValuePresetType = {
  factory: Expression;
  /** Name for the section where the preset will be displayed. */
  category: ValuePresetCategory;
  /** The map of icons displayed in the interface keyed by size. */
  icon: ValuePresetIcons;
  /** The preset name */
  label: string;
  /** Fields containing helpful information, usually to educate or instruct users. */
  helpData?: ValuePresetHelpData;
};

/**
 * Function to retrieve the `icon` property from an ValuePreset.
 */
export function getIcon(preset: ValuePresetType): ValuePresetIcons {
  return preset.icon;
}

/**
 * Function to retrieve the `category` property from an ValuePreset.
 */
export function getCategory(preset: ValuePresetType): ValuePresetCategory {
  return preset.category;
}

export const name = (key: string) => key as ValuePresetName;
